import React from 'react';
import { View, Text, ActivityIndicator, StyleSheet, Pressable, Platform, Dimensions } from 'react-native';

const LoadingScreen = ({ message = 'Cargando...' }) => {
  const getIsSmallScreen = () => {
    if (Platform.OS === 'web' && typeof window !== 'undefined') {
      return window.innerWidth < 768;
    }
    return Dimensions.get('window').width < 768;
  };

  const [isSmallScreen, setIsSmallScreen] = React.useState(getIsSmallScreen);

  React.useEffect(() => {
    if (Platform.OS === 'web' && typeof window !== 'undefined') {
      const handleResize = () => setIsSmallScreen(getIsSmallScreen());
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }
    const subscription = Dimensions.addEventListener?.('change', () => setIsSmallScreen(getIsSmallScreen()));
    return () => {
      if (subscription?.remove) {
        subscription.remove();
      }
    };
  }, []);

  // Evitamos que cualquier evento de clic o toque pase a través de esta capa
  const preventInteraction = (event) => {
    try {
      event.preventDefault?.();
      event.stopPropagation?.();
    } catch (_) {}
    return false;
  };

  return (
    <Pressable
      onPress={preventInteraction}
      onPressIn={preventInteraction}
      onPointerDown={preventInteraction}
      onMouseDown={preventInteraction}
      onTouchStart={preventInteraction}
      onTouchMove={preventInteraction}
      onWheel={preventInteraction}
      onStartShouldSetResponder={() => true}
      onMoveShouldSetResponder={() => true}
      onResponderGrant={preventInteraction}
      onResponderMove={preventInteraction}
      onResponderRelease={preventInteraction}
      style={styles.overlay}
    >
      <View style={[styles.card, isSmallScreen && styles.cardMobile]}>
        <View style={styles.brandBar} />
        <View style={styles.content}>
          <ActivityIndicator size="large" color="#e30613" style={styles.spinner} />
          <Text style={styles.message}>{message}</Text>
        </View>
      </View>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  overlay: {
    position: Platform.OS === 'web' ? 'fixed' : 'absolute', // Fixed para web, absolute para móvil
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)', // Fondo oscuro semi-transparente para bloquear visualmente
    zIndex: 2147483647,
    elevation: 1000, // Mayor elevación para Android
    display: 'flex', // Usar flexbox para centrar mejor el contenido
    justifyContent: 'center',
    alignItems: 'center',
    pointerEvents: 'auto',
    ...(Platform.OS === 'web'
      ? {
          backdropFilter: 'blur(4px)',
          WebkitBackdropFilter: 'blur(4px)',
          touchAction: 'none',
          overscrollBehavior: 'none',
        }
      : null),
  },
  card: {
    width: 420,
    maxWidth: '88%',
    borderRadius: 14,
    backgroundColor: '#ffffff',
    borderWidth: 1,
    borderColor: 'rgba(0,0,0,0.08)',
    overflow: 'hidden',
    ...(Platform.OS === 'web'
      ? { boxShadow: '0 18px 40px rgba(0,0,0,0.18)' }
      : {
          shadowColor: '#000',
          shadowOffset: { width: 0, height: 12 },
          shadowOpacity: 0.18,
          shadowRadius: 18,
          elevation: 10,
        }),
  },
  cardMobile: {
    width: 340,
  },
  brandBar: {
    height: 6,
    backgroundColor: '#e30613',
  },
  content: {
    paddingVertical: 26,
    paddingHorizontal: 22,
    justifyContent: 'center',
    alignItems: 'center',
  },
  spinner: {
    marginBottom: 14,
    transform: [{ scale: 1.25 }],
  },
  message: {
    fontSize: 18,
    color: '#111',
    textAlign: 'center',
    fontWeight: '700',
    marginTop: 4,
  }
});

export default LoadingScreen;
